import { BookingExtra } from "@/redux/slices/booking/types";

/**
 * The icon an operator picks for an extra in Config -> Fixed Cost Extras. The backend models these
 * as an enum (`JobAnalyzer\Enum\ExtraOptionImage`), so `baby-seat` is a deliberate tag on the
 * extra rather than a guess at what its name means.
 */
const BABY_SEAT_IMAGE = "baby-seat";

/**
 * Names that mean a child restraint even when the extra was left on another icon. Operators write
 * these freely — "Rear facing seat for under 9 months", "Booster seat for ages 3 to 7 years" — so
 * the tag alone under-reports, and under-reporting is the failure this chip exists to prevent.
 * Limited to wording that only describes a restraint in this domain.
 */
const BABY_SEAT_NAME = /\b(baby|infant|capsule|child(?:'s)? seat|booster|rear[ -]facing|forward[ -]facing)\b/i;

/** True when a booking's extras include a child restraint the operator has to physically fit. */
export const hasBabySeatExtra = (extras?: BookingExtra[]): boolean =>
  (extras ?? []).some((extra) => extra.image === BABY_SEAT_IMAGE || BABY_SEAT_NAME.test(extra.name ?? ""));
